/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { requestStreamDecks } from '@elgato-stream-deck/webhid';
import IconMic from './assets/images/stream-deck/mic-off.png';
import IconMicSlash from './assets/images/stream-deck/mic-off.png';
import IconBack from './assets/images/stream-deck/back.png';
import IconDown from './assets/images/stream-deck/down.png';
import IconUp from './assets/images/stream-deck/up.png';
import IconLeft from './assets/images/stream-deck/left.png';
import IconRight from './assets/images/stream-deck/right.png';
import IconMenu from './assets/images/stream-deck/menu.png';
import IconSelect from './assets/images/stream-deck/select.png';
import IconVideoWindow from './assets/images/stream-deck/video-window.png';
import IconVolumeUp from './assets/images/stream-deck/volume-up.png';
import IconVolumeDown from './assets/images/stream-deck/volume-down.png';
import IconWhiteboard from './assets/images/stream-deck/whiteboard.png';
import IconView from './assets/images/stream-deck/view.png';
import IconKnock from './assets/images/stream-deck/knock.png';
import IconJoinAudio from './assets/images/stream-deck/join-audio.png';
import IconLeaveAudio from './assets/images/stream-deck/leave-audio.png';
import IconGroup from './assets/images/stream-deck/groups.png';
import IconCensorOn from './assets/images/stream-deck/censor-on.png';
import IconCensorOff from './assets/images/stream-deck/censor-off.png';
import { sendMultiKnockMessage } from 'store/modules/chat/actions';
import { toggleWhiteboard } from 'store/modules/whiteboard/actions';
import { setVolume } from 'store/modules/filmstrip/actions';
import { toggleGroups, toggleSettings } from 'store/modules/settings/actions';
import {
  focusNextElement,
  focusPrevElement,
  selectElement
} from 'store/modules/keyboard-shortcuts/actions';
import { toggleTileView } from 'store/modules/video-layout/actions';

// App global state.
const state = {
  streamDeck: undefined,
  api: undefined,
  appId: '',
  room: '',
  jwt: '',
  audio: false,
  audioMuted: false,
  videoMuted: false,
  chatOpen: false,
  raisedHand: false,
  tileView: false
};

const FACTOR = 1;

function loadIcon(icon, label, canvas, size, background = 'white') {
  canvas.height = size;
  canvas.width = size;
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const ctx = canvas.getContext('2d');

      ctx.fillStyle = background;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, FACTOR / 2, 0, size - FACTOR, size - FACTOR);

      // ctx.fillStyle = 'black';
      // ctx.font = 'bold 12px sans-serif';
      // ctx.textAlign = 'center';
      // ctx.fillText(label, canvas.width / 2, size - FACTOR / 2);

      resolve();
    };
    img.src = icon;
  });
}
const deckButtons = [
  {
    pressHandler: handleWhiteboard,
    syncState: fillKeyCanvas,
    loadIcons: loadWhiteboardIcon
  },
  {
    pressHandler: handleGroup,
    syncState: fillKeyCanvas,
    loadIcons: loadGroupIcon
  },
  {
    pressHandler: handleAudio,
    syncState: syncAudioState,
    loadIcons: loadAudioIcons
  },
  {
    pressHandler: handleTileView,
    syncState: syncTileViewState,
    loadIcons: loadTileViewIcons
  },
  {
    pressHandler: handleKnock,
    syncState: fillKeyCanvas,
    loadIcons: loadKnockIcon
  },
  {
    pressHandler: handleVolumeUp,
    syncState: fillKeyCanvas,
    loadIcons: loadVolumeUpIcon
  },
  {
    pressHandler: handleAudioMute,
    syncState: syncAudioMuteState,
    loadIcons: loadAudioMuteIcons
  },
  {
    pressHandler: handleCensor,
    syncState: syncCensorState,
    loadIcons: loadCensorIcons
  },
  {
    pressHandler: handleUpClick,
    syncState: fillKeyCanvas,
    loadIcons: loadUpIcon
  },
  {
    pressHandler: handleSelect,
    syncState: fillKeyCanvas,
    loadIcons: loadSelectIcon
  },
  {
    pressHandler: handleVolumeDown,
    syncState: fillKeyCanvas,
    loadIcons: loadVolumeDownIcon
  },
  {
    pressHandler: handleMenu,
    syncState: fillKeyCanvas,
    loadIcons: loadMenuIcon
  },
  {
    pressHandler: handleLeftClick,
    syncState: fillKeyCanvas,
    loadIcons: loadLeftIcon
  },
  {
    pressHandler: handleDownClick,
    syncState: fillKeyCanvas,
    loadIcons: loadDownIcon
  },
  {
    pressHandler: handleRightClick,
    syncState: fillKeyCanvas,
    loadIcons: loadRightIcon
  }
];

export async function videoConferenceJoined({ roomName }) {
  state.room = roomName;
  updateStreamDeck();
}

export function readyToClose() {
  state.audioMuted = false;
  state.audio = false;
  state.videoMuted = false;
  state.chatOpen = false;
  state.raisedHand = false;
  state.tileView = false;
  if (state.streamDeck) {
    state.streamDeck?.clearPanel();
  }
}

export function audioStatusChanged({ enabled }) {
  state.audio = enabled;
  updateStreamDeck();
}

export function audioMuteStatusChanged({ muted }) {
  state.audioMuted = muted;
  updateStreamDeck();
}

export function videoMuteStatusChanged({ muted }) {
  state.videoMuted = muted;
  updateStreamDeck();
}

export function chatUpdated({ isOpen }) {
  state.chatOpen = isOpen;
  updateStreamDeck();
}

export function raiseHandUpdated({ handRaised }) {
  state.raisedHand = handRaised;
  updateStreamDeck();
}

export function tileViewChanged({ enabled }) {
  state.tileView = enabled;
  updateStreamDeck();
}

export function censorChanged({ enabled }) {
  state.censor = enabled;
  updateStreamDeck();
}

export async function connectStreamDeck() {
  let decks;

  try {
    decks = await requestStreamDecks();
  } catch (e) {
    console.error(e);

    return;
  }

  const [deck] = decks;
  if (!deck) {
    return;
  }

  state.streamDeck = deck;

  console.log('Serial:', await deck.getSerialNumber());
  console.log('Firmware:', await deck.getFirmwareVersion());

  await deck.clearPanel();

  deckButtons.forEach((x) =>
    x.loadIcons(deck.ICON_SIZE, deckButtons.indexOf(x), x)
  );

  deck.on('up', (keyIndex) => {
    // console.log('key %d up', keyIndex);
    deckButtons[keyIndex].pressHandler();
  });

  deck.on('error', (error) => {
    console.error('Stream Deck error: ', error);
  });
  setTimeout(() => {
    updateStreamDeck();
  }, 2000);
}

// Stream Deck controls.
//

function updateStreamDeck() {
  deckButtons.forEach((x) => x.syncState(deckButtons.indexOf(x), x));
}

// Audio mute
function handleAudioMute() {
  APP.conference.toggleAudioMuted(false /* no UI */);
}

function syncAudioMuteState(keyIdx, btnState) {
  // console.log('Current audio muted state: %s', state.audioMuted);
  state.streamDeck?.fillKeyCanvas(
    keyIdx,
    state.audioMuted ? btnState.canvas2 : btnState.canvas1
  );
}

// Video mute
function handleVideoMute() {
  APP.conference.toggleVideoMuted(false /* no UI */, true /* ensure track */);
}

function syncVideoMuteState(keyIdx, btnState) {
  // console.log('Current video muted state: %s', state.videoMuted);
  state.streamDeck?.fillKeyCanvas(
    keyIdx,
    state.videoMuted ? btnState.canvas2 : btnState.canvas1
  );
}

// join/leave audio
function handleAudio() {
  APP.conference.toggleAudio();
}

function syncAudioState(keyIdx, btnState) {
  // console.log('Current audio state: %s', state.audio);
  state.streamDeck?.fillKeyCanvas(
    keyIdx,
    state.audio ? btnState.canvas1 : btnState.canvas2
  );
}

function handleCensor() {
  APP.conference.toggleBlur();
}

function syncCensorState(keyIdx, btnState) {
  // console.log('Current audio state: %s', state.censor);
  state.streamDeck?.fillKeyCanvas(
    keyIdx,
    state.censor ? btnState.canvas1 : btnState.canvas2
  );
}

async function loadAudioMuteIcons(size, keyIdx, btnState) {
  btnState.canvas1 = document.createElement('canvas');
  await loadIcon(IconMic, 'Mute', btnState.canvas1, size);
  btnState.canvas2 = document.createElement('canvas');
  await loadIcon(IconMicSlash, 'Unmute', btnState.canvas2, size);
}

async function loadAudioIcons(size, keyIdx, btnState) {
  btnState.canvas1 = document.createElement('canvas');
  await loadIcon(IconJoinAudio, 'Join Audio', btnState.canvas1, size, 'green');
  btnState.canvas2 = document.createElement('canvas');
  await loadIcon(IconLeaveAudio, 'Leave Audio', btnState.canvas2, size, 'red');
}

async function loadVideoIcons(size, keyIdx, btnState) {
  btnState.canvas1 = document.createElement('canvas');
  await loadIcon(IconMic, 'Stop', btnState.canvas1, size);
  btnState.canvas2 = document.createElement('canvas');
  await loadIcon(IconMicSlash, 'Start', btnState.canvas2, size);
}

async function loadCensorIcons(size, keyIdx, btnState) {
  btnState.canvas1 = document.createElement('canvas');
  await loadIcon(IconCensorOn, 'Censor On', btnState.canvas1, size);
  btnState.canvas2 = document.createElement('canvas');
  await loadIcon(IconCensorOff, 'Censor Off', btnState.canvas2, size);
}

async function loadKnockIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconKnock, 'Knock', btnState.canvas, size);
}

async function loadGroupIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconGroup, 'Groups', btnState.canvas, size);
}

// Tile view
function handleTileView() {
  APP.store.dispatch(toggleTileView());
}

function syncTileViewState(keyIdx, btnState) {
  state.streamDeck?.fillKeyCanvas(
    keyIdx,
    state.tileView ? btnState.canvas2 : btnState.canvas1
  );
}

async function loadTileViewIcons(size, keyIdx, btnState) {
  btnState.canvas1 = document.createElement('canvas');
  await loadIcon(IconView, 'Tile View', btnState.canvas1, size);
  btnState.canvas2 = document.createElement('canvas');
  await loadIcon(IconView, 'Stage View', btnState.canvas2, size, 'gray');
}

// Hangup
function handleHangup() {
  APP.conference.hangup();
}

// Knock
function handleKnock() {
  APP.store.dispatch(sendMultiKnockMessage());
}

// Whiteboard
function handleWhiteboard() {
  APP.store.dispatch(toggleWhiteboard());
}

// Group
function handleGroup() {
  const { conferenceGroups } = APP.store.getState()['features/settings'];
  APP.store.dispatch(toggleGroups(!conferenceGroups));
}

// volume up
function handleVolumeUp() {
  const state = APP.store.getState();
  const p = state['features/large-video'].participantId;
  const { participantsVolume } = state['features/filmstrip'];
  if (p) {
    APP.store.dispatch(setVolume(p.id, (participantsVolume[p] ?? 1) + 1));
  }
}

// volume down
function handleVolumeDown() {
  const state = APP.store.getState();
  const p = state['features/large-video'].participantId;
  const { participantsVolume } = state['features/filmstrip'];
  if (p) {
    APP.store.dispatch(setVolume(p.id, (participantsVolume[p] ?? 10) - 1));
  }
}

// toggle menu
function handleMenu() {
  const { conferenceSetting } = APP.store.getState()['features/settings'];
  APP.store.dispatch(toggleSettings(!conferenceSetting));
}

// back
function handleBack() {
  //
}

// Up
function handleUpClick() {
  APP.store.dispatch(focusPrevElement());
}

// Left
function handleLeftClick() {
  APP.store.dispatch(focusPrevElement());
}

// Right
function handleRightClick() {
  APP.store.dispatch(focusNextElement());
}

// Down
function handleDownClick() {
  APP.store.dispatch(focusNextElement());
}

// Select
function handleSelect() {
  APP.store.dispatch(selectElement());
}

function fillKeyCanvas(keyIdx, btnState) {
  state.streamDeck?.fillKeyCanvas(keyIdx, btnState.canvas);
}

async function loadVWIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(
    IconVideoWindow,
    'VideoWindow',
    btnState.canvas,
    size,
    'black'
  );
}

async function loadBackIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconBack, 'Back', btnState.canvas, size, 'blue');
}

async function loadMenuIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconMenu, 'Menu', btnState.canvas, size, 'lightblue');
}

async function loadWhiteboardIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconWhiteboard, 'Whiteboard', btnState.canvas, size);
}

async function loadSelectIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconSelect, 'Select', btnState.canvas, size);
}

async function loadUpIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconUp, 'Up', btnState.canvas, size);
}

async function loadLeftIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconLeft, 'Left', btnState.canvas, size);
}

async function loadRightIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconRight, 'Right', btnState.canvas, size);
}

async function loadDownIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconDown, 'Down', btnState.canvas, size);
}
async function loadVolumeUpIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconVolumeUp, 'Volume Up', btnState.canvas, size);
}
async function loadVolumeDownIcon(size, keyIdx, btnState) {
  btnState.canvas = document.createElement('canvas');
  await loadIcon(IconVolumeDown, 'Volume Down', btnState.canvas, size);
}
